import React from 'react';

export default function Footer() {
  return (
    <footer>
      <div className="source">
        Source: ABS, Characteristics of Employment (COE) survey, August 2025
      </div>
    </footer>
  );
}
